export const LAST_LOGIN_HINT_KEY = 'lastLoginHint';

// Logout wipes localStorage entirely for session hygiene, but the "Continue
// as X" login hint is meant to survive logout — that's the point of it,
// so it's captured and restored around the clear instead of being wiped.
export function clearLocalStorageKeepingLoginHint() {
  const hint = localStorage.getItem(LAST_LOGIN_HINT_KEY);
  localStorage.clear();
  if (hint) {
    localStorage.setItem(LAST_LOGIN_HINT_KEY, hint);
  }
}
